
import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import LeagueDetails from '@/components/LeagueDetails';
import PlayerNav from '@/components/PlayerNav';
import { useIsMobile } from '@/hooks/use-mobile';

const LeagueDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState('my-events');
  const [showRegistration, setShowRegistration] = useState(false);
  
  const leagueId = id || '1';

  useEffect(() => {
    // Check if URL has #registration hash to show registration form
    if (location.hash === '#registration') {
      setShowRegistration(true);
      // Scroll to registration section after component mounts
      setTimeout(() => {
        const registrationElement = document.getElementById('registration-section');
        if (registrationElement) {
          registrationElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.hash]);

  const handleBack = () => {
    navigate('/');
  };

  const handleTabClick = (tabId: string) => {
    if (activeTab === tabId) {
      // If clicking on the same tab, reset to main
      navigate('/');
    } else {
      // Normal tab navigation - navigate to home with tab parameter
      navigate(`/?tab=${tabId}`);
    }
  };

  const handleNotificationClick = () => {
    console.log("Navigate to notifications screen");
  };

  const handleChatClick = () => {
    console.log("Navigate to chats screen");
  };

  const handleContactOrganizer = () => {
    // Navigate to chat with organizer
    navigate(`/chat/${leagueId}?organizerName=Organizador&organizerAvatar=👨‍💼`);
  };

  // Mock notification and chat counts
  const notificationCount = 3;
  const chatCount = 2;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1b3521] via-[#31633f] to-[#6da079]">
      <PlayerNav 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onTabClick={handleTabClick}
        onNotificationClick={handleNotificationClick}
        onChatClick={handleChatClick}
        notificationCount={notificationCount}
        chatCount={chatCount}
      />
      
      <main className={`container mx-auto ${isMobile ? 'px-2 pt-2 pb-20' : 'px-4 pt-4 pb-20'}`}>
        <LeagueDetails 
          leagueId={leagueId}
          onBack={handleBack}
          showRegistration={showRegistration}
          onContactOrganizer={handleContactOrganizer}
        />
      </main>
    </div>
  );
};

export default LeagueDetailsPage;
